module.exports = __webpack_public_path__ + "static/media/icon-remove.ae67c678.svg";